import { Button, Checkbox } from "@mantine/core";
import { useEffect, useState } from "react";
import { PaymentBankProps, tableDataProps } from "../../../types/types";


export function TableData(props: tableDataProps){
 
  const [paymentEnabledBanks, setPaymentEnabledBanks] = useState<any>({});
 

  useEffect(() => {
    const method = () => {
      let initialValue: any = {};
      if(props.bankNameSuccess && props.bankNameSuccess.length > 0){
        props.bankNameSuccess.forEach((obj) => initialValue[obj.paymentProvideType] = true)
      }
      setPaymentEnabledBanks(initialValue);
    }
    method();
  }, [props.bankNameSuccess]);

    return(
      <tr >
        <td>{props.dat.branch}</td>
        <td>{props.dat.district}</td>
        <td>{props.dat.outletcode}</td>
        <td className="outletName">{props.dat.outlet_name}</td>
        {/* {props.dat.onboarded_in ? <td>{props.dat.onboarded_in}</td>: ''} */}
        {props.banks.map((bank: PaymentBankProps) => {return (
        <td >
        <Checkbox
            checked = {paymentEnabledBanks[bank.id]}
            onChange={(event) => {
              let copyOfPaymentEnabledBanks = {...paymentEnabledBanks};
              if(paymentEnabledBanks && paymentEnabledBanks[bank.id]) {
                copyOfPaymentEnabledBanks[bank.id] = false;
              }
              else {
                copyOfPaymentEnabledBanks[bank.id] = true;
                //setPaymentEnabledBanks(bank.id);
              }
              setPaymentEnabledBanks(copyOfPaymentEnabledBanks);
            }}
            //disabled={props.bankNameSuccess ? (props.bankNameSuccess.paymentProvideType === bank.id? false:true):false}
          />
          </td>
            )})}
        <td><Button style={{ backgroundColor: "#02BBd5" }}onClick={() => props.submitForm(paymentEnabledBanks, props.dat.outletcode, props.dat.id)}>Submit</Button></td>
        
      </tr>
    
    )
}